import { useState } from 'react';

import { Card } from '../../components/Card';
import { Button } from '../../components/Button';
import { Text } from '../../components/Text';
import classes from './TestScreen.module.css';
import type { InsperaObject } from '../../interface/interface';

interface EndScreenProps {
    insperaDetails: InsperaObject;
}
const EndScreen = ({ insperaDetails }: EndScreenProps) => {
    const [openFeedbackLink, setOpenFeedbackLink] = useState(false);

    const getFeedbackFormLink = (product: string) => {
        console.log('product type', product);
        switch (product) {
            case 'GT_TRIAL':
                return process.env.REACT_APP_FEEDBACK_FORM_LINK_GT_TRIAL;
            case 'HOELT':
                return process.env.REACT_APP_FEEDBACK_FORM_LINK_HOELT;
            default:
                return process.env.REACT_APP_FEEDBACK_FORM_LINK;
        }
    };

    const feedbackFormLink = getFeedbackFormLink(insperaDetails.product);

    return openFeedbackLink ? (
        <div className={classes.msFormCard}>
            <iframe
                title="ICMST"
                width="100%"
                height="100%"
                src={feedbackFormLink}
                allowFullScreen
                style={{ border: '2px solid transparent' }}
            >
                Feedback form loading...
            </iframe>
        </div>
    ) : (
        <Card className={classes.endMessageCard}>
            <Text text="The Speaking test is finished." fontWeight="bold" />
            <Text text="You can give feedback on this Speaking test by clicking below." />
            <Button
                size="xl"
                onClick={() => {
                    setOpenFeedbackLink(true);
                }}
            >
                Provide feedback
            </Button>
        </Card>
    );
};

export default EndScreen;
